import { ClassV2Session } from '@/shared/api-generated-types'

export function soonestNonExpiredSession(sessions?: ClassV2Session[], durationSeconds?: number): ClassV2Session | null {
  if (!sessions?.length || !durationSeconds) return null
  const now = new Date()
  let soonestSession = null
  for (const session of sessions) {
    if (!session.start) continue
    const sessionStart = new Date(session.start)
    const sessionEnd = new Date(sessionStart.getTime() + durationSeconds * 1000)
    // Check if the session has already elapsed
    if (sessionEnd > now) {
      if (!soonestSession || !soonestSession.start || sessionStart < new Date(soonestSession.start)) {
        soonestSession = session
      }
    }
  }
  return soonestSession
}
